module.exports = __webpack_public_path__ + "static/black-math-101d4e293a5a4a0f8fa2b427a4f00007.png";